export const environment = {
  production: true,
  encrypt:true,
  api: 'https://apidma.loyaltysp.es',
  apikey: 'chPDtWjPejVqVj5cPjPK1X3ULEWHlY2Z',
  apiKeyConfig: 'f3af2516-97fb-4927-af25-1697fb7927cb',
  keyEncrypt:'e61d729f6a2026ec54fb491c1a865dd619210399054006f60444b3cfe1f210f5',
  keycloakUrl: 'https://kcdm2.loyaltysp.es',
  keycloakRealm: 'DMA_9cg9hra0Y',
  keycloakClientId: 'social',
  client: 'front-social',
  sedeUrl: 'https://api.diputacion.malaga.es',
  imagePath: 'https://d19ahwwoi13m5b.cloudfront.net'
};